// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3CTe4","upload":"Small_upload__1TXbq","imageWrap":"Small_imageWrap__3qw_g","removeBtn":"Small_removeBtn__cYP5J"};